<template>
    <VideoVariationLayout variation-modifier="slice-video--default" :primary="slice.primary" :video-players="videoPlayers" />
</template>

<script setup lang="ts">
    import {computed, onMounted} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {VideoSlice, VideoSliceDefault} from '@prismicio-types';
    import useErrorHelpers from '../../../composables/useErrorHelpers';
    import {useVideoEmbedPlayer} from '../../../composables/useVideoEmbedPlayer';
    import VideoVariationLayout from '../VideoVariationLayout.vue';

    const props = defineProps(getSliceComponentProps<VideoSlice>());
    const slice = computed(() => props.slice as VideoSliceDefault);
    const {mapToVideoPlayerProps} = useVideoEmbedPlayer();

    const videoPlayers = computed(() => [
        mapToVideoPlayerProps({
            video: slice.value.primary.video,
            title: slice.value.primary.text,
            cover: slice.value.primary.cover,
            size: slice.value.primary.size,
        }),
    ]);

    onMounted(() => {
        const {getPreviewErrorHandler, throwIfPrimaryPropertiesAreInvalid} = useErrorHelpers();
        const errorHandler = getPreviewErrorHandler();
        if (errorHandler.enabled) {
            throwIfPrimaryPropertiesAreInvalid(errorHandler.toast, props.slice.primary, [{name: 'title', type: 'field'}], 'video slice');
            throwIfPrimaryPropertiesAreInvalid(errorHandler.toast, props.slice.primary, [{name: 'video', type: 'video'}], 'video slice');
        }
    });
</script>
